<template>
  <b-form @submit="onSubmit">
    <b-row>
      <b-col sm class="mt-4">
        <b-form-input
          v-model.trim="$v.form.fr.$model"
          :placeholder="$t('label.languages.fr')"
        ></b-form-input>
        <div
          class="text-danger"
          v-if="!$v.form.fr.required && $v.form.fr.$dirty"
        >
          {{ $t("info.required") }}
        </div>
        <div
          class="text-danger"
          v-if="!$v.form.fr.maxLength && $v.form.fr.$dirty"
        >
          {{ $t("info.maxLength", [75]) }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm class="mt-4">
        <b-form-input
          v-model.trim="$v.form.en.$model"
          :placeholder="$t('label.languages.en')"
        ></b-form-input>
        <div
          class="text-danger"
          v-if="!$v.form.en.required && $v.form.en.$dirty"
        >
          {{ $t("info.required") }}
        </div>
        <div
          class="text-danger"
          v-if="!$v.form.en.maxLength && $v.form.en.$dirty"
        >
          {{ $t("info.maxLength", [75]) }}
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm class="mt-4">
        <strong>{{ $t("label.category") }}</strong>
        <b-form-select
          v-model="form.categorie"
          :options="categories"
        ></b-form-select>
        <div
          class="text-danger"
          v-if="!$v.form.categorie.required && $v.form.categorie.$dirty"
        >
          {{ $t("info.required") }}
        </div>
      </b-col>
    </b-row>

    <div v-if="spinner" class="text-center">
      <b-spinner
        style="width: 3rem; height: 3rem"
        variant="success"
        label="Spinning"
        disabled="labelStatus"
      ></b-spinner>
    </div>

    <b-button
      class="mt-4 text-center"
      type="submit"
      variant="success"
      :disabled="disabled"
      >{{ $t("action.submit") }}</b-button
    >

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>
  </b-form>
</template>

<script>
import axios from "axios";
import { required, maxLength } from "vuelidate/lib/validators";
import { globalF } from "../../Helpers";

export default {
  mixins: [globalF],
  props: ["modalid", "item", "source", "mode"],
  data() {
    return {
      form: {
        fr: this.getItem("fr"),
        en: this.getItem("en"),
        categorie: this.getCategorie(),
      },
      error: "",
      disabled: false,
      spinner: false,
    };
  },
  validations() {
    return {
      form: {
        fr: {
          required,
          maxLength: maxLength(75),
        },
        en: {
          required,
          maxLength: maxLength(75),
        },
        categorie: {
          required,
        },
      },
    };
  },
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      //let url = process.env.VUE_APP_WHERE === "home" ? urls.homeup : urls.workup;
      return urls[process.env.VUE_APP_WHERE];
    },
    categories: function () {
      let categories = this.getGlobalData("provenanceCategorie");
      return categories.map((c) => {
        return {
          value: c.Id,
          text: c.fr,
        };
      });
    },
  },
  methods: {
    getItem: function (lg) {
      let value = "";
      if (this.item) {
        value = lg === "fr" ? this.item.fr : this.item.en;
      }
      return value;
    },
    getCategorie() {
      let value = "";
      if (this.item) {
        value = this.item.categorie;
      }
      return value;
    },
    onSubmit(evt) {
      evt.preventDefault();

      this.error = "";
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.spinner = true;
        this.disabled = true;
        let promise = this.validateToken();
        promise.then(() => {
          this.form.status = 1;
          this.form.listOrder = 0; //getorderfromlist ??? || no listOrder (will be last item)

          if (this.mode === "update") {
            this.form.Id = this.item.Id;
          }

          this.ajaxCall();
        });
      }
    },
    ajaxCall: function () {
      this.spinner = true;
      axios
        .post(
          this.url.json,
          {
            request: "dispatchRequestMenu",
            form: this.form,
            source: this.source,
            mode: this.mode,
          },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
          let res = response.data;
          if (res === 0) {
            this.$store.commit("setReloadValue", true);
            this.$bvModal.hide(this.modalid);
          } else {
            this.error = this.$t("info.errorgeneric");
            this.disabled = false;
          }
          this.spinner = false;
        })
        .catch(() => {
          this.error = this.$t("info.errorgeneric");
          this.disabled = false;
          this.spinner = false;
        });
    },
  },
};
</script>
